import { months, weekdays } from '../strings.sv';

export default {
  tabSE: 'DeliveryPortal Sweden',
  tabFI: 'DeliveryPortal Finland',
  ordersOverview: {
    modalHeader: 'Beställningsöversikt',
    formFilterHeader: 'Filtrering',
    formFilterOrdersHeader: 'Filtrera beställningar',
    filterInputPlaceholder: 'Sök på adress',
    mapMenuButton: 'Beställningsöversikt',
    importPlannedDates: 'Importera Planerade Datum',
    importSuccess: 'Planerade datum uppdaterade',
    importError: 'Import misslyckades, försök igen.',
    downloadExcel: 'Ladda ned Excel',
    downloadSuccess: 'Excel-fil nedladdad',
    downloadError: 'Excel-filen kunde inte hämtas.',
    downloadPdfStarted:
      'Genererar PDF för {address}. PDF-generering kan ta ett tag beroende på rapportstorleken.',
    downloadPdfSuccess: 'PDF nedladdad',
    downloadPdf429Title: 'Vänta',
    downloadPdfError429:
      'PDF-generering är upptagen. Vänta en stund och försök igen.',
    downloadPdfErrorGeneric: 'Kunde inte generera PDF. Försök igen.',
    downloadPdfCancelled:
      'PDF-nedladdningen avbröts eftersom tabellen stängdes.',
    filterOptions: {
      showAll: 'Visa alla',
      incomplete: 'Visa ej färdiga',
      complete: 'Visa färdiga',
    },
    tableHeaders: {
      address: 'Fastighetsadress',
      customerType: 'Typ',
      customerName: 'Kundnamn',
      completedDate: 'Färdigställt datum',
      latestStatus: 'Senaste status',
      statusDate: 'Datum för status',
      netAdminId: 'NetAdmin ID',
      customerInstallationDate: 'Installationsdatum',
      pdf: 'PDF',
      planedInstallationDate: 'Planerad kundinstallation',
      bookedCustomerInstallationDate: 'Bokad kundinstallation',
      siteProjectPlanningExecutedDate: 'Tomtprojektering utförd',
      siteShaftBooked: 'Tomtschakt bokad',
      siteShaftInstallationDate: 'Tomtschakt utförd',
      fiberCableInstalledForCustomer: 'Fiber blåst',
      fiberReceiverInstallationDate: 'Fibermottagare installerad',
      plotDesignDate: 'Kundprojektering',
      preinstallationDate: 'Kundinstallation',
      plotExcavationDate: 'Tomtschakt',
      ductConnection: 'Dukt Koppling',
      cableBlowingDate: 'Fiberblåsning',
      splicingAndMeasuringDate: 'Skarvning & OTDR',
      splicingAndMeassuringDate: 'Skarvning & OTDR',
      splicingDate: 'Skarvning',
      commissioningDate: 'Driftsättning',
      measuringDate: 'Mätning',
      macAddress: 'MAC-adress CPE',
      macNetAdminId: 'MAC & NetAdmin ID',
      buildingName: 'Byggnadsnamn',
      buildingId: 'Byggnads-ID',
      deliveryPoints: 'Leveranspunkter (levererade/totalt)',
    },
    true: 'Ja',
    false: 'Nej',
    error: 'Kunde inte hämta ordrar, vänligen försök igen senare.',
    latestStatus: {
      ORDERED: 'Beställt',
      ORDERED_FOR_BUILD: 'Lämnat till bygg',
      CANCELLED: 'Cancellerad',
      REVOKED: 'Anullerad',
      WITHDRAWN: 'Ångrad',
      ESCALATED: 'Eskalerad',
      CONSTRUCTION_DEVIATION: 'Avvikelse byggledning',
      NOT_VALIDATED: 'Ej validerad',
      WARNING: 'Varning',
      INSTALLED: 'Installerad',
      UNKNOWN: 'Okänd',
    },
    status: 'Status',
    reportDetails: {
      true: 'Ja',
      false: 'Nej',
      deliveryPoints: 'Leveranspunkter',
      itemPerPage: 'Antal per sida',
      labels: {
        address: 'Fastighetsadress',
        propertyDesignation: 'Fastighetsbeteckning',
        deliveryContact: 'Kontakt för leverans',
        phone: 'Telefonnummer',
        email: 'E-post',
        housingNetwork: 'Bostadsnät',
        netType: 'Nättyp',
        propertyConnection: 'Fastighetsanslutning',
        connectionType: 'Anslutningstyp',
        propertyNetwork: 'Fastighetsnät',
      },
      propertyNetwork: {
        EXISTING: 'Befintlig',
        CONSTRUCTION: 'Byggnation',
      },
      networkType: {
        OWN_NETWORK: 'Eget nätverk',
        KO: 'Kommunikationsoperatör',
        ACQUIRED: 'Accepterad',
        RENTAL: 'Uthyrning',
      },
      connectionType: {
        ONGOING_CONSTRUCTION_AREA: 'Pågående byggarbetsområde',
        RENT: 'Hyra',
        KO: 'Kommunikationsoperatör',
        EXISTING: 'Befintlig',
      },
      constructionType: {
        HANDED_TO_CONSTRUCTION: 'Överlämnad till byggverksamheten',
        STARTED: 'Startad',
        FINISHED: 'Färdig',
        OBSTRUCTION: 'Hinder',
        PLANNED: 'Planerad',
        MIGRATION_ONGOING: 'Migration pågår',
        MIGRATED: 'Migrerad',
      },
      constructionStatus: {
        utbyggnad: 'Utbyggnad',
        HANDED_TO_CONSTRUCTION: 'Överlämnad till byggverksamheten',
        STARTED: 'Startad',
        FINISHED: 'Färdig',
        OBSTRUCTION: 'Hinder',
        PLANNED: 'Planerad',
        MIGRATION_ONGOING: 'Migration pågår',
        MIGRATED: 'Migrerad',
      },
    },
    deliveryPointsTable: {
      mac: 'MAC',
      id: 'ID',
    },
  },
  installationReport: {
    popUpBtnText: 'Progressrapportering',
    header: 'Progressrapportering',
    saveBtn: 'Spara rapport',
    dismissBtn: 'Avbryt',
    addressLabel: 'Address',
    toOrdersModal: 'Till beställningsöversikt',
    confirmModal: {
      header: 'Är du säker att du vill stänga modalen?',
      text: 'Det finns osparande ändringar, se till att spara dem innan du stänger modalen.',
      cancelBtn: 'Tillbaka till rapporten',
      closeBtn: 'Stäng modalen!',
    },
    missingIdMessage: 'Progressrapportering saknar id (sourceKey)',
    saveSuccessMessage: 'Progressrapportering har sparats!',
    saveErrorMessage:
      'Kunde inte spara Progressrapportering. Var vänlig försök igen.',
    failToLoadMessage: {
      403: 'Behörighet saknas för att ladda Progressrapportering.',
      404: 'Progressrapportering i vald bostad saknas.',
      408: 'Request Timeout. Vänligen ladda om sidan.',
      500: 'Problem med servern, vänligen försök igen senare.',
      general: 'Progressrapportering kunde inte laddas.',
    },
    errorText:
      'Kunde inte ladda rapporten. Vänligen ladda om rapporten eller försök igen senare.',
    form: {
      planedInstallationDate: 'Planerad kundinstallation',
      bookedCustomerInstallationDate: 'Bokad kundinstallation',
      siteProjectPlanningExecutedDate: 'Tomtprojektering utförd',
      siteShaftBooked: 'Tomtschakt bokad',
      siteShaftInstallationDate: 'Tomtschakt utförd datum',
      fiberCableInstalledForCustomer: 'Fiber blåst hos kund',
      fiberReceiverInstallationDate: 'Installation av Fibermottagare',
      macAddress: 'MAC-adress CPE',
      email: 'Email',
      name: 'Namn',
      phoneNumber: 'Telefonnummer',
    },
  },
  installationReportV2: {
    tabNames: {
      ORDER_OVERVIEW: 'Beställningsöversikt',
      PLOT_DESIGN: 'Kundprojektering',
      PLOT_EXCAVATION: 'Tomtschakt',
      DUCT_CONNECTION: 'Dukt Koppling',
      PRE_INSTALLATION: 'Kundinstallation',
      SPLICING_MEASURING: 'Skarv & OTDR',
      SPLICING: 'Skarv',
      CABLE_BLOWING: 'Fiberblåsning',
      COMMISSIONING: 'Driftsättning',
      MEASURING: 'Mätning',
    },
    modal: {
      header: 'Installationsrapport',
      completedBy: 'Färdigställd av #{user} #{date}',
      closeBtn: 'Stäng',
      saveBtn: 'Spara',
      completeBtn: 'Färdigställ rapport',
      unlockReportBtn: 'Lås upp rapport',
      reportCompletedBtn: 'Rapport färdigställd',
      reportCompletedDisabledTooltip:
        'Kontakta din byggledare för att få rapporten upplåst.',
      completeBtnDisabledTooltip:
        'Rapporten kan färdigställas när alla faser är helt avslutade.',
      onProceedError: 'Installationsrapporten är felaktigt ifylld',
      cannotSaveNetAdmin: 'Kan inte spara NetAdmin värde.',
    },
    completeConfirmation: {
      title: 'Färdigställ rapport?',
      whatHappens: 'Vad händer om du bekräftar?',
      bulletInvoice: 'Kunden faktureras direkt efter bekräftelse.',
      bulletLocked: 'Hela rapporten låses och kan inte ändras.',
      checkboxLabel: 'Jag har läst och förstått texten ovan.',
      cancel: 'Avbryt',
      confirm: 'Bekräfta',
      completedTitle: 'Rapport färdigställd!',
      completedBody:
        'Kunden har beställts och fakturan har skickats! Denna rapport kan inte längre redigeras.',
      closeWindow: 'Stäng detta fönster',
    },
    plotDesignTab: {
      instructions: 'Fyll i informationen för att slutföra.',
      completed: 'Kundprojektering - Avklarad!',
      plannedPlotDesign: 'Planerad Kundprojektering',
      executedPlotDesign: 'Utförd Kundprojektering',
      comment: 'Kommentar',
      awaitingSign: 'Inväntar signering',
      completedSign: 'Signering avklarad',
      initiateSign: 'Påbörja signering',
    },
    plotExcavationTab: {
      instructions: 'Fyll i informationen för att slutföra.',
      completed: 'Tomtschakt - Avklarad!',
      plannedPlotExcavation: 'Planerad Tomtschakt',
      executedPlotExcavation: 'Utförd Tomtschakt',
      comment: 'Kommentar',
    },
    ductConnectionTab: {
      instructions: 'Utför egenkontroll för att slutföra Dukt Koppling',
      completed: 'Dukt Kopplad',
      executedDate: 'Utförd datum',
      notConnected: 'Ej kopplad',
      comment: 'Kommentar',
    },
    orderOverviewTab: {
      markAsBom: 'Markera som BOM',
      bomTag: 'BOM',
      comment: 'Kommentar',
      commentPlaceholder: 'Kommentar...',
      save: 'Spara',
      cancel: 'Avbryt',
      undoBom: 'Ångra BOM',
      markAsBomError: 'Det gick inte att markera leveranspunkten som BOM',
      undoBomError: 'Det gick inte att ångra BOM för leveranspunkten',
      infoText:
        'Information om den vald beställning finns nedan. Fyll i rapporterna i flikarna ovan.',
      subHeader: 'Beställningsinformation',
      address: 'Adress',
      customerName: 'Kundnamn',
      email: 'Email',
      phoneNumber: 'Telefonnummer',
      connectionType: 'Anslutningstyp',
      contactedDate: 'Kund Kontaktad',
      statusReport: 'Rapportstatus',
      customerType: 'Möjlighetstyp',
      greenfieldIfs: 'Greenfield-IFS',
      greenfieldProjectAccessDeniedHeading: 'Projektåtkomst krävs',
      greenfieldProjectAccessDeniedMessage:
        'Du har inte åtkomst till detta projekt. Kontakta din administratör om du behöver åtkomst.',
      greenfieldProjectAccessDeniedClose: 'Stäng',
      doneTag: 'KLAR',
    },
    preinstallationTab: {
      instructions: 'Fyll i informationen och utför kontroll.',
      completed: 'Kundinstallation - Avklarad!',
      plannedPreinstallation: 'Planerad Kundinstallation',
      executedPreinstallation: 'Utförd Kundinstallation',
      macAddress: 'MAC-adress CPE / Serienummer',
      macAddressInputLabel:
        'MAC-adress CPE (P2P) eller Serienummer ONT (XGS-PON)',
      help: 'Hjälp',
      comment: 'Kommentar',
      netAdmin: 'NetAdmin',
      netAdminHeader: 'ONT / CPE-registrering',
      netAdminSubHeader:
        'Välj enhet och fyll i värde nedan. Spara för att registrera!',
      deviceCategory: 'Enhetstyp',
      deviceValue: 'Enhetsvärde',
      macSerialPlaceholder: 'MAC / Serienummer',
      mustMatchFormat: 'Måste matcha format:',
      netAdminStatus: {
        saveToUpload:
          'Fyll i MAC-adress CPE / Serienummer och Spara för att ladda upp!',
        notSaved: 'Ej sparad',
        cannotUpload:
          'Sparad - men kan inte ladda upp utan utfört datum och slutförda egenkontroller.',
        clickSave: 'Klicka på Spara för att ladda upp till NetAdmin!',
        uploading: 'Skickat till NetAdmin!',
        uploaded: 'Uppladdad & Sparad',
      },
      inputPlaceHolder: 'MAC-address CPE eller Serienummer',
      maxInput: 'Max 17 tecken tillåtet.',
      incorrectFormat: 'Ogiltigt format, se Hjälp för instruktioner.',
      snackbarInfo:
        'Om du vill ändra det aktuella värdet, kontakta ansvarig Projektledare på GlobalConnect.',
      model: 'Modell',
      selection: 'Välj',
    },
    splicingAndMeasuringTab: {
      instructions: 'Fyll i informationen och ladda upp filer!',
      completed: 'Skarvning & OTDR - Avklarad!',
      plannedMeasuring: 'Planerad OTDR',
      executedMeasuring: 'Utförd OTDR',
      plannedSplicing: 'Planerad Skarvning',
      executedSplicing: 'Utförd Skarvning',
      fileAndImageUpload: 'Fil- och bilduppladdning',
      upload: 'Ladda upp',
      showImages: 'Visa bilder',
      comment: 'Kommentar',
      commentDescriptionExplanation:
        'Vänligen ange orsaken till att du inte följer panelkortet.',
      fiberData: {
        title: 'Fiberuppgifter',
        panelcard: {
          question: 'Följt Panelkortet?',
          yes: 'Ja',
          no: 'Nej',
        },
        switchName: 'Switchnamn',
        switchPort: 'Switchport',
        switchCard: 'Switchblad',
        odfInSite: 'ODF i Nod',
        odfContact: 'Kontakt i ODF',
        cabinet: 'FOS (Fiber Optiskt Skåp)',
        cableIdCabinet: 'Kabelnamn i FOS/Brunn',
        fiberInCabinet: 'Fiber i FOS',
        ductColorInCabinet: 'Ductfärg i FOS/Brunn',
        splitterPort: 'Splitterport',
        splitterName: 'Splitternamn',
        placeholders: {
          syntax: 'NNNN000-NN0',
          number: 'Nummer',
          focType: 'Ange FOS',
          focCableId: 'Ange Kabelnamn',
          color: 'Ange Duktfärg',
          name: 'Ange namn',
          select: 'Välj',
        },
        descriptions: {
          switchNameSyntax: 'Föreslaget format NNNNN0000-NN0',
        },
      },
      toast: {
        notFollowingPanelcard:
          'Ange anledningen till att du inte följer panelkortet i kommentaren.',
      },
    },
    cableBlowingTab: {
      instructions: 'Fyll i informationen för att slutföra detta moment.',
      completed: 'Fiberblåsning - Avklarad!',
      plannedCableBlowing: 'Planerad Fiberblåsning',
      executedCableBlowing: 'Utförd Fiberblåsning',
      comment: 'Kommentar',
    },
    commissioningTab: {
      instructions: 'Fyll i informationen och genomför kontrollerna.',
      completed: 'Driftsättning - Avklarad!',
      plannedCommissioning: 'Planerad Driftsättning',
      executedCommissioning: 'Utförd Driftsättning',
      plannedMeasuring: 'Planerad Mätning',
      executedMeasuring: 'Utförd Mätning',
      comment: 'Kommentar',
    },
    selfInspection: {
      markAsComplete: 'Markera som klar',
      uploadImage: 'Ladda upp bild',
      showControlled: 'Visa kontrollerade',
      undoSelfInspection: 'Ångra egenkontroll',
      handleImage: 'Hantera bilder',
      showAttachments: 'Visa bilagor',
      updateSelfInspectionErrorMessage: 'Egenkontroll kunde inte uppdateras',
      notApplicableText: 'Ange anledning',
      cancel: 'Avbryt',
      markAsNonApplicable: 'Markera som icke-applicerbar',
      notApplicable: 'Icke-applicerbar',
      editNotApplicableComment: 'Redigera beskrivning',
      saveChanges: 'Spara',
      updateSelfInspectionSuccessMessage: 'Beskrivningen är uppdaterad',
      selfInspectionSavedSuccessMessage: 'Egenkontrollen är sparad',
      revertSelfInspectionMessage: 'Egenkontrollen är ångrad',
      updateSelfInspectionFilesMessage: 'Egenkontrollens filer är updaterade',
      updateSelfInspectionRevertedMessage:
        'Uppladdningen av bilder cancellerades',
      uploadSelfInspectionImageSuccess: 'Bilder uppladdadade!',
      uploadSelfInspectionImageError:
        'Kunde inte ladda upp bilder. Försök igen!',
      deleteSelfinspectionImageSuccess: 'Bilden har blivit borttagen.',
      deleteSelfinspectionImageError: 'Kunde inte ta bort bild.',
      loadingImages: 'Laddar bilder...',
      instructionalImage: {
        DepthExampleImage: 'Inkludera måttstock i bilden - Se exempel',
      },
      done: 'Klar: ',
      na: 'N/A: ',
    },
    updateInstallationReportSuccess: 'Dina ändringar är nu sparade',
    updateInstallationReportError: 'Dina ändringar kunde inte sparas',
    clearDate: 'Rensa datum',
    alerts: {
      executedDateAlert: 'Se till att alla egenkontroller är ifyllda',
      signReady: 'Redo för signering',
    },
    imageChecklist: {
      title: 'Bild-checklista',
      listItems: {
        splicingOutlet: 'Bild på skarv i fiberuttag/fasadbox',
        splicingFOS: 'Bild på skarv i FOS',
        sealingDuctFOS: 'Bild på tätning av dukt i FOS',
        hasOdfPortImage: 'Bild på ODF port',
        hasSwitchPortImage: 'Bild på Switchport',
        hasNodeImage: 'Före och efter bild i site',
      },
    },
  },
  macAddressInvalid: 'Felaktig MAC-adress',
  Huvudbyggnad: 'Huvudbyggnad',
  Extraanslutning_seperat_byggnad: 'Extraanslutning seperat byggnad',
  Extraanslutning_inom_huvudbyggnad: 'Extraanslutning inom huvudbyggnad',
  datepickerPlaceholder: 'YYYY-MM-DD',
  imagePreview: {
    upload: 'Ladda upp',
    cancel: 'Avbryt',
    header: 'Förhandsvisning',
    noImages: 'Inga bilder att visa',
    loadingImages: 'Laddar...',
  },
  imagePreviewV2: {
    preview: 'Förhandsvisning',
    addImages: 'Lägg till bilder',
    close: 'Stäng',
    downloadAll: 'Ladda ner alla',
    editImages: 'Redigera bilder',
    manageImages: 'Hantera bilder',
    done: 'Klar',
    deleteImageQuestion: 'Ta bort bild?',
    confirmDelete: 'Ja, ta bort',
    cancel: 'Avbryt',
    confirmDeleteText: 'Är du säker på att du vill radera denna bild?',
    pleaseWait: 'Vänligen vänta...',
    download: 'Ladda ner',
    images: 'Bilder',
    imageDeleted: 'Bild borttagen',
    saved: 'Sparat!',
    uploaded: 'Uppladdad',
    noImagesAvailable: 'Inga bilder tillgängliga',
    addImagesBelow: 'Du kan lägga till bilder nedan!',
  },
  dateFormatError: 'Du har fyllt i ett felaktigt datum (ÅÅÅÅ-MM-DD).',
  tableConfiguration: {
    title: 'Anpassa tabell',
    cancel: 'Avbryt',
    apply: 'Applicera',
    showAllColumns: 'Visa alla kolumner',
  },
  ...months,
  ...weekdays,
  workSectionStatus: {
    EXECUTED: 'Utförd',
    PLANNED: 'Planerad',
    AWAITING_PLANNING: 'Inväntar planering',
    INCOMPLETE: 'Ej fullständig',
  },
  workSectionStatusTooltip: {
    EXECUTED: 'Arbetet har slutförts',
    PLANNED: 'Arbetet har planerats men inte slutförts än',
    AWAITING_PLANNING: 'Arbetet har inte planerats än',
    INCOMPLETE: 'Utförd med ofullständiga egenkontroller',
  },
  ductConnectionStatus: {
    NOT_CONNECTED: 'Ej kopplad',
  },
  fileUpload: {
    error: 'Filerna kunde inte laddas upp',
    loadingImages: 'Laddar bilder...',
  },
  select: 'Välj ',
  tableFilter: {
    orderFilterssSectionHeader: ' valda filter',
    addFilterButton: 'Lägg till filter',
    applyFilterButton: 'Använd filter',
    clearAllFiltersButton: 'Rensa alla filter',
    noFilteredOrders: 'Inga beställningar hittades.',
    accessId: {
      existing: 'NetAdmin ID - Befintlig',
      notExisting: 'NetAdmin ID - Obefintlig',
    },
    plotDesign: {
      planned: 'Projektering - Planerad',
      awaitingPlanning: 'Projektering - Inväntar planering',
      executed: 'Projektering - Utförd',
    },
    preinstallation: {
      planned: 'Installation - Planerad',
      awaitingPlanning: 'Installation - Inväntar planering',
      executed: 'Installation - Utförd',
    },
    plotExcavation: {
      planned: 'Tomtschakt - Planerad',
      awaitingPlanning: 'Tomtschakt - Inväntar planering',
      executed: 'Tomtschakt - Utförd',
    },
    ductConnection: {
      connected: 'Dukt Koppling - Kopplad',
      notConnected: 'Dukt Koppling - Ej Kopplad',
    },
    cableBlowing: {
      planned: 'Fiberblåsning - Planerad',
      awaitingPlanning: 'Fiberblåsning - Inväntar planering',
      executed: 'Fiberblåsning - Utförd',
    },
    measuring: {
      planned: 'Skarv & OTDR - Planerad',
      awaitingPlanning: 'Skarv & OTDR - Inväntar planering',
      executed: 'Skarv & OTDR - Utförd',
    },
    commission: {
      planned: 'Driftsättning - Planerad',
      awaitingPlanning: 'Driftsättning - Inväntar planering',
      executed: 'Driftsättning - Utförd',
    },
    perPage: 'Visa per sida: ',
  },
  feedbackAlert: {
    upload: {
      fileSuccess: 'Fil(er) uppladdade',
      success: 'Bild(er) uppladdade',
      error: 'Misslyckades. Försök igen',
      signatureAlreadyExist: 'Signatur existerar redan, ta bort gamla först.',
      couldNotConfirm: 'Kunde inte bekräfta. Försök igen',
    },
    undoSelfInspection: {
      success: 'Egenkontroll Ångrad',
      error: 'Misslyckades. Försök igen',
    },
    markAsNA: {
      success: 'Markerad som N/A',
      error: 'Misslyckades. Försök igen',
    },
    save: {
      success: 'Sparat',
      error: 'Misslyckades. Försök igen',
    },
    remove: {
      success: 'Borttagen',
      error: 'Misslyckades. Försök igen',
    },
    get: {
      signatureError: 'Signatur kan inte hämtas. Försök igen',
      downloadError: 'Nedladdning misslyckades. Försök igen',
      preparingDownload: 'Förbereder nedladdning, vänligen vänta...',
    },
  },
  signing: {
    header: 'Signering',
    back: 'Tillbaka',
    confirm: 'Bekräfta',
    CONTRACTOR: 'Entreprenör',
    CUSTOMER: 'Kund',
    signAsCONTRACTOR: 'Signera som entreprenör',
    signAsCUSTOMER: 'Signera som kund',
    infoText:
      'Lägg till båda signaturerna och bekräfta för att slutföra signeringen.',
  },
  signingSummary: {
    customerInformation: 'Kundinformation',
    address: 'Adress',
    propertyDesignation: 'Fastighetsbeteckning',
    name: 'Fullständigt namn',
    email: 'E-post',
    mobileNumber: 'Mobilnummer',
    homeNumber: 'Hemtelefonnummer',
    plotDesign: 'Tomtprojektering',
    executedDate: 'Utfört datum',
    selfInspections: 'Egenkontroller',
    notApplicable: 'Ej applicerbar',
    comment: 'Kommentar',
    confirming: 'Bekräftar...',
  },
  signingConfirmationModal: {
    headerTitle: 'Bekräftat',
    return: 'Tillbaka till rapport',
    download: 'Ladda ner kopia',
    title: 'Allt är klart!',
    paragraph: 'Kopia har skickats till e-post.',
    paragraphV2: 'Signerade kopian kan laddas ner!',
  },
  signaturePad: {
    clear: 'Rensa',
    close: 'Stäng',
    save: 'Spara',
    remove: 'Ta bort signatur',
  },
  signingCard: {
    title: 'Signering av Kundprojektering',
    information:
      'Utför alla obligatoriska egenkontroller och ange utfört datum för att aktivera signering.',
    startSigning: 'Börja signering',
    newSigning: 'Ny signering',
  },
  signingErrorScreen: {
    reportDoesNotExist: 'Denna rapport finns inte',
    unableToStartSigning: 'Det gick inte att börja signera!',
    reportMissingData:
      'Rapporten saknar utfört datum eller har ofullständig egenkontroll.',
    goToReport: 'Gå till rapport',
    signingCouldNotBeStarted: 'Signering kunde inte påbörjas!',
    refreshOrTryAgain: 'Uppdatera eller försök igen senare.',
    refreshPage: 'Uppdatera sida',
  },
  rotateDeviceMessage: 'Rotera enheten horisontellt',
  copied: 'Kopierad',
  portConnectionStatus: {
    portConnection: 'Portanslutning',
    noMac: 'Ingen giltig MAC-adress eller serienummer i installation',
    toPreinstallation: 'Gå till installation',
    checkStatus: 'Kontrollera portanslutningens status för beställningen.',
    checkConnection: 'Kontrollera anslutning',
    loadingState: 'Kontrollerar status. Vänligen vänta...',
    linking: 'Länkar',
    notLinking: 'Inte länkad',
    installationDate: 'Installationsdatum: ',
    checkAgain: 'Kontrollera igen',
    debugMessage: 'Vänligen felsök och försök igen.',
  },
  pageSizepicker: { all: 'Alla' },
  tabletoolBar: {
    building: 'Byggnader',
    deliveryPoint: 'Leveranspunkter',
    itemsPerPage: 'Antal per sida',
    search: 'Sök',
    searchPlaceholder: 'Sök',
  },
  installationReportingMduTable: {
    legend: {
      building: 'Byggnad',
      deliveryPoint: 'Leveranspunkt',
    },
    constructionStatus: {
      PLANNED: 'Planerad',
      HANDED_TO_CONSTRUCTION: 'Överlämnad till bygg',
      STARTED: 'Påbörjad',
      FINISHED: 'Färdig',
      OBSTRUCTION: 'Hinder',
      MIGRATION_ONGOING: 'Migrering pågår',
      MIGRATED: 'Migrerad',
    },
    headers: {
      buildingName: 'Byggnadsnamn',
      status: 'Status',
      macAccessId: 'MAC och Access ID',
    },
    labels: {
      macAddress: 'MAC:',
      accessId: 'Access ID:',
    },
    status: {
      inProgress: 'Pågår',
      approved: 'Godkänd',
      completed: 'Slutförd',
      underReview: 'Under granskning',
      notApplicable: 'Ej tillämpbar',
    },
  },
  installationReportingMduModal: {
    header: 'Installationsrapport',
  },
  buildingPageModal: {
    header: 'Installationsrapport byggnad',
    deliveryProject: 'Leveransprojekt',
    comment: 'Kommentar',
    commentPlaceholder: 'Skriv något...',
    commentPlaceholderPhase: 'Skriv en kommentar...',
    sectionNotApplicable: {
      markAsNotApplicable: 'Markera som ej tillämpbar',
      reasonLabel: 'Lägg till orsak för ej tillämpbar',
      reasonPlaceholder: 'Skriv en orsak...',
      cancel: 'Avbryt',
      tag: 'EJ TILLÄMPBAR',
      commentTitle: 'Kommentar',
      by: 'Av',
      reactivate: 'Återaktivera egenkontroll',
      saveError: 'Kunde inte uppdatera sektionens status ej tillämpbar.',
    },
    optional: 'Valfri',
    uploadedFileCount: 'Uppladdade filer: ',
    signing: {
      performedBy: 'Signering utförs av',
      deliveryContact: 'Kontakt för leverans',
    },
    selfInspections: {
      plotDesign: {
        item1:
          'Kontrollera att tomtprojekteringen stämmer med installationsförutsättningarna.',
        item1_1: 'Kontrollera att nödvändiga tillstånd och godkännanden finns.',
        item2: 'Markera kabelsträckan och anslutningspunkten.',
        item2_1:
          'Kontrollera att den markerade sträckan är fri för installation.',
        item3:
          'Kontrollera att nödvändigt material och utrustning finns tillgängligt.',
        item4: 'Kontrollera planerad placering av kundutrustning.',
        item6: 'Dokumentera avvikelser från tomtprojekteringen.',
        item7: 'Fotografera den färdiga tomtprojekteringen.',
        item7_1: 'Kontrollera att fotodokumentationen är komplett.',
        item8: 'Kontrollera att tillämpliga säkerhetskrav är uppfyllda.',
        item10: 'Dokumentera annan relevant information.',
      },
      preinstallation: {
        item1: 'Kontrollera placeringen av CPE eller ONT.',
        item2: 'Kontrollera strömförsörjningen.',
        item3: 'Fotografera placeringen av CPE eller ONT.',
        item4: 'Fotografera kabelsträckan.',
        item5: 'Fotografera fiberuttaget.',
        item6: 'Fotografera utrustningens etikett.',
      },
      plotExcavation: {
        item1: 'Fotografera schaktsträckan.',
        item2: 'Fotografera schaktdjupet.',
        item2_1: 'Fotografera varningsbandet.',
        item3: 'Fotografera återställd yta.',
      },
      ductConnection: {
        item1: 'Fotografera anslutna rör.',
      },
      cableBlowing: {
        item1: 'Fotografera kabelblåsningsinstallationen.',
        item1_extra: 'Se till att kabelmärkningen syns på bilden.',
      },
    },
    notImplementedYet: 'Inte implementerat an. Andringar sparas inte.',
  },
};
